module.exports = __webpack_public_path__ + "media/scholarships/no_new_matches_background-d1d121e7.jpg";